const user = {
    username_already_in_use: '該使用者名稱已被使用。',
    username_starts_with_number: '使用者名稱不能以數字開頭。',
    username_invalid_charset_hard: '使用者名稱只能包含字母、數字和下劃線。',
    username_too_short: '使用者名稱太短。',
    username_too_long: '使用者名稱太長。',
    username_uppercase_not_allowed: '使用者名稱不能包含大寫字母。',
    username_lowercase_not_allowed: '使用者名稱不能包含小寫字母。',
    username_numbers_not_allowed: '使用者名稱不能包含數字。',
    username_underscore_not_allowed: '使用者名稱不能包含下劃線。',
    email_already_in_use: '該電子郵件地址已被使用。',
    phone_already_in_use: '該手機號碼已被使用。',
    invalid_email: '電子郵件地址不正確。',
    invalid_phone: '手機號碼不正確。',
    email_not_exist: '電子郵件地址尚未註冊。',
    phone_not_exist: '手機號碼尚未註冊。',
    identity_not_exist: '該社交帳號尚未註冊。',
    sso_identity_not_exist: '該企業單一登入帳戶尚未註冊。',
    identity_already_in_use: '該社交帳號已被註冊。',
    social_account_exists_in_profile: '你已綁定當前社交帳號，無需重複操作。',
    cannot_delete_self: '無法刪除自己的帳戶。',
    sign_up_method_not_enabled: '註冊方式尚未啟用。',
    sign_in_method_not_enabled: '登錄方式尚未啟用。',
    same_password: '為確保帳戶安全，新密碼不能與舊密碼一致。',
    password_required_in_profile: '請設置登錄密碼。',
    new_password_required_in_profile: '請設置新密碼。',
    password_exists_in_profile: '當前使用者已設置密碼，無需重複操作。',
    username_required_in_profile: '請設置使用者名稱。',
    username_exists_in_profile: '當前使用者已設置使用者名稱，無需重複操作。',
    email_required_in_profile: '請綁定電子郵件地址',
    email_exists_in_profile: '當前使用者已綁定電子郵件，無需重複操作。',
    phone_required_in_profile: '請綁定手機號碼。',
    phone_exists_in_profile: '當前使用者已綁定手機號碼，無需重複操作。',
    email_or_phone_required_in_profile: '請綁定電子郵件地址或手機號碼。',
    suspended: '帳戶已被禁用。',
    user_not_exist: '未找到與 {{identifier}} 相關聯的使用者。',
    missing_profile: '請於登錄時提供必要的使用者補充資訊。',
    role_exists: '角色識別碼 {{roleId}} 已添加到此使用者',
    invalid_role_type: '無法設置機械到機械角色給使用者。',
    suggest_mfa: '為提升帳戶安全性，我們建議你將多因素驗證綁定到你的帳戶。',
    missing_mfa: '你需要在登錄前綁定額外的多因素驗證。',
    totp_already_in_use: '時間型一次性密碼（TOTP）已經在使用中。',
    backup_code_already_in_use: '備份代碼已經在使用中。',
    password_algorithm_required: '密碼算法為必填項。',
    password_and_digest: '你不能同時設置明文密碼和密碼摘要。',
    personal_access_token_name_exists: '個人存取權杖名稱已存在。',
    totp_secret_invalid: '提供的時間型一次性密碼（TOTP）密鑰無效。',
    wrong_backup_code_format: '備份代碼格式無效。',
    username_required: '使用者名稱是必填識別符，你不能將其設為null。',
    email_or_phone_required: '電子郵件地址或手機號碼是必填識別符，至少需要一個。',
    last_sign_in_method_required: '你的帳戶至少需要保留一種可用的登入方式。',
    email_required: '電子郵件地址是必填識別符，你不能將其設為null。',
    phone_required: '手機號碼是必填識別符，你不能將其設為null。',
    enterprise_sso_identity_not_exists: '該使用者沒有企業身份鏈接到指定的單一登入連接器識別碼：{{ ssoConnectorId }}。',
    identity_not_exists_in_current_user: '指定的身份在當前使用者帳戶中不存在。請先鏈接該身份再繼續。',
    passkey_preferred: '建立通行密鑰以簡化登入流程。',
};
export default Object.freeze(user);
